import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { svgWithJs, variables } from '../../variables';

import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelopeOpenText, faLock } from '@fortawesome/pro-solid-svg-icons';

@customElement('apt-icon')
export class AptIcon extends LitElement {
  @property({ type: Object }) data = {
    type: faEnvelopeOpenText,
    text: {
      inner: '',
      outer: ''
    },
    class: 'fa fa-envelope-open-text',
    optionalType: ''
  };
  @property({ type: Boolean }) disabled = false;
  @property({ type: Object }) properties = {
    height: '18px',
    width: '18px',
    padding: '0',
    iconSize: '18px',
    textSize: '12px',
    color: 'black',
    bgColor: 'transparent',
    hoverColor: 'transparent',
    hoverBgColor: 'transparent',
    disabledColor: 'transparent',
    disabledBgColor: 'transparent',
    iconTextBottom: '14px',
  };


  static override get styles() {
    return [
      variables,
      svgWithJs,
      css`
        .label-holder{
          display: flex;
          justify-content: flex-start;
          gap: 6px;
        }
        .chip-lock {
          cursor: pointer;
          border-radius: 16px;
          line-height: 22px;
          display: flex;
          place-content: center;
          .alert-text {
            margin: 0 4px;
            font-size: 12px;
          }
        }
        .icon-span {
          position: relative;
          display: inline-block;
          bottom: 0px;
        }
      `,
    ];
  }

  override render() {
    return html`
      <div class="label-holder" style="font-size: ${this.properties.textSize}">
        <div class="chip-lock"
          @mouseenter="${(event: any) => {
        event.target.style.color = `var(--${this.properties.hoverColor})`
        event.target.style['background-color'] = `var(--${this.properties.hoverBgColor})`
      }}"
          @mouseleave="${(event: any) => {
        event.target.style.color = `var(--${this.getColor()})`;
        event.target.style['background-color'] = `var(--${this.getBgColor()})`;
      }}"
          style="
            color: var(--${this.getColor()});
            background-color: var(--${this.getBgColor()});
            cursor: ${this.getCursor()};
            width: ${this.properties.width};
            height: ${this.properties.height};
            padding: ${this.properties.padding};
            ">
            <div style="font-size: ${this.properties.iconSize};">
              <i class="${this.data.class}"></i>
            </div>
            ${this.data.text?.inner ?
        html`<span class="alert-text">${this.data.text.inner}</span>` : nothing
      }
          </div>
          ${this.data.text?.outer ?
        html`<span>${this.data.text.outer}</span>` : nothing
      }
        </div>
      `;
  }

  getBgColor() {
    return this.disabled ? this.properties.disabledBgColor : this.properties.bgColor;
  }

  getColor() {
    return this.disabled ? this.properties.disabledColor : this.properties.color;
  }

  getCursor() {
    return this.disabled ? 'not-allowed' : 'pointer';
  }

  protected override firstUpdated(): void {
    if (this.data.optionalType === 'faLock') {
      library.add(faLock);
    } else {
      library.add(this.data.type);
    }



    // @ts-expect-error The dom.watch() TS definition indicates no parameters for this. However, when
    // you actually dig into the code, you see that it looks at the arguments after it gets into
    // the code and tries to pull some out if there aren't any (it even supplies an empty object
    // for options if you don't supply one yourself).
    //
    // Note: We have to wait for the first update for the shadow DOM to even be created.
    dom.watch({
      autoReplaceSvgRoot: this.shadowRoot,
      observeMutationsRoot: this.shadowRoot,
    });
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'apt-icon': AptIcon;
  }
}
